import type { FieldApi } from '@tanstack/react-form'
import { cn } from 'lib/utils'

interface FieldInfoProps<T> {
  // biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
  field: FieldApi<T, any, any, any>
  errorClassName?: string
}

export const FieldInfo = <T,>({ field, errorClassName }: FieldInfoProps<T>) => {
  if (field.state.meta.errors?.length) {
    const showAsList = errorClassName?.includes('error-list-format')

    // Split comma-separated errors only when list format is requested
    const allErrors = showAsList
      ? field.state.meta.errors.flatMap((error) =>
          typeof error === 'string' && error.includes(', ') ? error.split(', ') : [error],
        )
      : field.state.meta.errors

    return (
      <div
        className={cn(
          'text-destructive text-s-400 mt-1 col-span-full field-error-message',
          errorClassName,
        )}
      >
        {showAsList && allErrors.length > 1 ? (
          <ul className="list-disc list-inside space-y-0.5">
            {allErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        ) : (
          allErrors.join(', ')
        )}
      </div>
    )
  }
  return null
}
